import { Component, OnInit } from '@angular/core';
import { MobileAppWrapper } from '../mobile.app.wrapper.component';
import { MobileAppSubpage } from '../mobile-store/mobile.data';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { openConfirmDeleteGetResult } from '../../dialog.confirmDelete.component';
import { mobileHomePageMenuReselector } from '../mobile-store/mobile.app.reselector';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../icon/icon.component';
import { mobileAppFeature } from '../mobile-store/mobile.app.era';

declare global {
  interface Window {
    uniqueId: string
    firebaseToken: string
  }
}

@Component({
    selector: 'mobile-app-options',
    template: `
<div class="menu-top">
  <icon [icon]="'hamburger'"></icon>
  <h1>Menu</h1>
</div>

<div class="menu-wrapper">
  <div *ngFor="let sub of subPages; first as first" [class.first]="first" class="menu-item" (click)="changeSubpage(sub)">
    <icon [icon]="pageIcons[sub]"></icon>
    {{ tabNames[mobileAppSubpageToTabId[sub]] || pageNames[sub] }}
  </div>
</div>

<div class="menu-wrapper">
  <div class="menu-item first" (click)="removeApp($event)">
    <icon [icon]="'MOBILE_EXIT'"></icon>
    Remove event from phone
  </div>
</div>

<div class="menu-wrapper">
  <div class="menu-item first" (click)="logout()">
    <icon [icon]="'MOBILE_EXIT'"></icon>
    Exit this event
  </div>
</div>
<div class="debug-panel" (click)="debugClicks = debugClicks + 1">
  <ng-container *ngIf="debugClicks >= 3">
    From flutter: {{ fromFlutter }}<br/>
    Unique id: {{ uniqueId }}<br/>
    Token: {{ token }}
  </ng-container>
</div>


`,
    styleUrls: ['./mobile-app.options.scss'],
    standalone: true,
    imports: [CommonModule, IconComponent,]
})
export class MobileAppOptionsComponent extends MobileAppWrapper<MobileAppOptionsComponent> implements OnInit {
  unfilteredSubPages: MobileAppSubpage[] = ['home', 'program', 'agenda', 'performers', 'sponsors', 'exhibitors', 'notifications', 'feedback']
  subPages: MobileAppSubpage[] = []
  appId: string
  debugClicks: number = 0
  tabNames: { [tId: string]: string } = getDefaultProgramTabNames()
  deleteTitle = 'Remove event'
  deleteText = 'Are you sure you want to remove this event from your phone?'

  get fromFlutter() { return window.fromFlutter }
  get uniqueId() { return window.uniqueId }
  get token() { return window.firebaseToken }
  
  ngOnInit() {
    this.subProp(this.store.select(mobileAppFeature.selectId), 'appId')
    this.selectCallback(mobileHomePageMenuReselector, null, subPages => {
      const basePages: MobileAppSubpage[] = ['home', 'agenda', 'notifications', 'feedback']
      this.subPages = this.unfilteredSubPages.filter(p => basePages.includes(p) || subPages.includes(p))
    })
  }

  changeSubpage(subPage: MobileAppSubpage) {
    this.mobileAppService.changeSubpage(subPage)
  }

  async removeApp(event) {
    event.stopPropagation()
    const data = {
      title: this.deleteTitle,
      rect: event.target.getBoundingClientRect(),
      para: this.deleteText,
      deleteButtonText: 'REMOVE',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    
    this.mobileAppService.removeAppById(this.appId)
    this.logout()
  }

  logout() {
    this.mobileAppService.exitApp()
  }

  constructor() {
    super()
    this.subProp(this.store.select(mobileAppFeature.selectTabNames), 'tabNames')
  }

}

